export enum ListingUserRoles {
  MANAGEMENT = 'MANAGEMENT',
  OWNER = 'OWNER',
}
